function createStorage(storageClient) {
  return {
    setItem(key, data) {
      try {
        storageClient.setItem(key, data);
      } catch (error) {
        console.error('Failed to set an item in a storage: %s', error.stack);
      }
    },
    stringifyAndSetItem(key, data) {
      try {
        storageClient.setItem(key, JSON.stringify(data));
      } catch (error) {
        console.error('Failed to set an item in a storage: %s', error.stack);
      }
    },
    getItem(key) {
      let data;
      try {
        data = storageClient.getItem(key);
      } catch (error) {
        console.error('Failed to get an item from a storage: %s', error.stack);
      }
      return data;
    },
    getItemAndParse(key) {
      let parsed;
      try {
        parsed = JSON.parse(storageClient.getItem(key));
      } catch (error) {
        console.error('Failed to get an item from a storage: %s', error.stack);
      }
      return parsed;
    },
    removeItem(key) {
      try {
        storageClient.removeItem(key);
      } catch (error) {
        console.error('Failed to remove an item from a storage: %s', error.stack);
      }
    },
    clear() {
      try {
        storageClient.clear();
      } catch (error) {
        console.error('Failed to clear a storage: %s', error.stack);
      }
    },
  };
}

export const localStorageClient = createStorage(window.localStorage);
export const sessionStorageClient = createStorage(window.sessionStorage);
